import { EnumOptions, FacilityOperatingStatus } from "@/types";
import { gql } from "@apollo/client";

export type FacilityDetailsHeaderQueryResponse = {
  facility: {
    id: string;
    name: string;
    /** CRM facility legacy id (CCMS facility_id); backend resolves ServiceBus universal id */
    legacyId: string | null;
    operatingStatus: FacilityOperatingStatus | null;
    section: {
      id: string;
      name: string;
    } | null;
    archivedAt: string | null;
  };
  operatingStatusOptions: EnumOptions<FacilityOperatingStatus>;
};

export const GET_FACILITY_DETAILS = gql`
  query GetFacilityDetails($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      name
      section {
        id
        name
      }
    }
  }
`;

export const FACILITY_DETAILS_HEADER_QUERY = gql`
  query FacilityDetailsHeader($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      name
      legacyId
      operatingStatus
      section {
        id
        name
      }
      archivedAt
    }
    operatingStatusOptions: __type(name: "FacilityOperatingStatus") {
      enumValues {
        name
        description
      }
    }
  }
`;
